import React from 'react';

const ChevronIcon = () => (
	<svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<mask
			id='mask0_1334_19306'
			style={{ maskType: 'alpha' }}
			maskUnits='userSpaceOnUse'
			x='0'
			y='0'
			width='25'
			height='25'
		>
			<rect x='0.5' y='0.5' width='24' height='24' fill='#D9D9D9' />
		</mask>
		<g mask='url(#mask0_1334_19306)'>
			<path d='M11.3 12.5008L15.2 16.4008C15.3833 16.5841 15.475 16.8174 15.475 17.1008C15.475 17.3841 15.3833 17.6174 15.2 17.8008C15.0167 17.9841 14.7833 18.0758 14.5 18.0758C14.2167 18.0758 13.9833 17.9841 13.8 17.8008L9.2 13.2008C9.1 13.1008 9.02917 12.9924 8.9875 12.8758C8.94584 12.7591 8.925 12.6341 8.925 12.5008C8.925 12.3674 8.94584 12.2424 8.9875 12.1258C9.02917 12.0091 9.1 11.9008 9.2 11.8008L13.8 7.20078C13.9833 7.01745 14.2167 6.92578 14.5 6.92578C14.7833 6.92578 15.0167 7.01745 15.2 7.20078C15.3833 7.38411 15.475 7.61745 15.475 7.90078C15.475 8.18411 15.3833 8.41745 15.2 8.60078L11.3 12.5008Z' />
		</g>
	</svg>
);

const Right = () => (
	<svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<mask
			id='mask0_1334_19331'
			style={{ maskType: 'alpha' }}
			maskUnits='userSpaceOnUse'
			x='0'
			y='0'
			width='25'
			height='25'
		>
			<rect x='0.5' y='0.5' width='24' height='24' fill='#D9D9D9' />
		</mask>
		<g mask='url(#mask0_1334_19331)'>
			<path d='M13.1 12.5008L9.19999 8.60078C9.01665 8.41745 8.92499 8.18411 8.92499 7.90078C8.92499 7.61745 9.01665 7.38411 9.19999 7.20078C9.38332 7.01745 9.61665 6.92578 9.89999 6.92578C10.1833 6.92578 10.4167 7.01745 10.6 7.20078L15.2 11.8008C15.3 11.9008 15.3708 12.0091 15.4125 12.1258C15.4542 12.2424 15.475 12.3674 15.475 12.5008C15.475 12.6341 15.4542 12.7591 15.4125 12.8758C15.3708 12.9924 15.3 13.1008 15.2 13.2008L10.6 17.8008C10.4167 17.9841 10.1833 18.0758 9.89999 18.0758C9.61665 18.0758 9.38332 17.9841 9.19999 17.8008C9.01665 17.6174 8.92499 17.3841 8.92499 17.1008C8.92499 16.8174 9.01665 16.5841 9.19999 16.4008L13.1 12.5008Z' />
		</g>
	</svg>
);

const Down = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M12 16C11.7 16 11.5 15.9 11.3 15.7C10.2 14.6 7.9 12.3 6.8 11.2C6.4 10.8 6.4 10.2 6.8 9.8C7.2 9.4 7.8 9.4 8.2 9.8C9.1 10.7 12 13.6 12 13.6C12 13.6 14.8 10.7 15.8 9.8C16.2 9.4 16.8 9.4 17.2 9.8C17.6 10.2 17.6 10.8 17.2 11.2C16.1 12.3 13.8 14.6 12.7 15.7C12.5 15.9 12.3 16 12 16Z' />
	</svg>
);

const Up = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M12 8C12.3 8 12.5 8.1 12.7 8.3C13.8 9.4 16.1 11.7 17.2 12.8C17.6 13.2 17.6 13.8 17.2 14.2C16.8 14.6 16.2 14.6 15.8 14.2C14.9 13.3 12 10.4 12 10.4C12 10.4 9.2 13.3 8.2 14.2C7.8 14.6 7.2 14.6 6.8 14.2C6.4 13.8 6.4 13.2 6.8 12.8C7.9 11.7 10.2 9.4 11.3 8.3C11.5 8.1 11.7 8 12 8Z' />
	</svg>
);

ChevronIcon.Right = Right;
ChevronIcon.Down = Down;
ChevronIcon.Up = Up;

export default ChevronIcon;
